import { render, staticRenderFns } from "./ProductPreview.vue?vue&type=template&id=034aaec4"
import script from "./ProductPreview.vue?vue&type=script&lang=js"
export * from "./ProductPreview.vue?vue&type=script&lang=js"
import style0 from "./ProductPreview.vue?vue&type=style&index=0&id=034aaec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports